import { render, staticRenderFns } from "./AddUnidade.vue?vue&type=template&id=33408423"
import script from "./AddUnidade.vue?vue&type=script&lang=js"
export * from "./AddUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports